import { render, staticRenderFns } from "./MoreFeature.vue?vue&type=template&id=6e8100ae&scoped=true"
import script from "./MoreFeature.vue?vue&type=script&lang=js"
export * from "./MoreFeature.vue?vue&type=script&lang=js"
import style0 from "./MoreFeature.vue?vue&type=style&index=0&id=6e8100ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8100ae",
  null
  
)

export default component.exports